import { useLocation } from 'react-router-dom';
import { AuthBrand, authBrands } from '../config/authBrand';
import { AppRouteKey } from '../utilities/router';

/**
 * Auth ekranlarının markasını route'a göre çözer. Platform (HEDEFNET/FILOMINGO)
 * build-time sabittir; Copilot parola sayfası ise aynı build içinde kendi
 * logosu ve banner'ı ile görünmelidir.
 */
const useAuthBrand = (): AuthBrand => {
  const { pathname } = useLocation();
  const isCopilot = pathname.endsWith(AppRouteKey.COPILOTNEWPASSWORD);
  return isCopilot ? authBrands.COPILOT : authBrands.PLATFORM;
};

export default useAuthBrand;
